import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import {axios_tenant} from '../../../../axios';
import { useAppContext } from '../AppContext';
import { toast } from 'react-toastify';

function CopyLinkMenuItems({ selectedItem, handleCloseContextMenu, showSnackbar  }) {
  const appData = useAppContext();

  const handleCopyLinkClick = async () => {
    try {
      const { folderId, fileId, type } = selectedItem;
      const folderIds = type === 'folder' ? [folderId] : [];
      const fileIds = type === 'file' ? [fileId] : [];
      const userIds = []; // Add logic to get selected user IDs

      // Send a POST request to create a share link
      const response = await axios_tenant.post(`/collaboration/createShareLink`, {
        folderIds,
        fileIds,
        userIds,
      });

      const shareLink = response.data.shareLink;
       // Copy the share link to clipboard
       await navigator.clipboard.writeText(window.location.origin + shareLink);

       // Show success snackbar
       toast.success('Link Copied to Clipboard');
      //  showSnackbar('Link Copied to Clipboard', false);

      // Handle sharing logic as needed (e.g., display a modal with the share link)
    } catch (error) {
      // Show error snackbar
      toast.error('Error creating share link');
      // showSnackbar('Error creating share link', true);
    }
    handleCloseContextMenu();
  };

  return (
    <>
      <MenuItem onClick={handleCopyLinkClick}>
        <FileCopyOutlinedIcon fontSize="small" style={{ marginRight: 8 }} /> Copy Link
      </MenuItem>
    </>
  );
}

export default CopyLinkMenuItems;
